// Hook pour utiliser la nouvelle API des requests et meetings
import { useCallback } from "react";
import * as newApi from "../server/Explanations CRUD/Requests/newRequests";
import type {
  CreateRequestInput,
  ValidateRequestDto,
  RejectRequestDto,
  ProposeSlotsDto,
  CreateMeetingDto,
  UpdateMeetingLinkDto,
  RequestResponse,
  MeetingResponse,
} from "../server/Explanations CRUD/Requests/newRequests";

export const useRequestsApi = () => {
  // ===== REQUESTS - STUDENTS =====

  /**
   * POST /requests - Create a course explanation request
   */
  const createRequest = useCallback(async (input: CreateRequestInput) => {
    console.log("🟢 [API] createRequest - Envoi de la demande:", input);
    return await newApi.createRequest(input);
  }, []);

  /**
   * GET /requests/mine - Get my requests
   */
  const getMyRequests = useCallback(async () => {
    console.log("🟢 [API] getMyRequests - Récupération des demandes");
    return await newApi.getMyRequests();
  }, []);

  /**
   * GET /requests/{id}/slots - Get proposed time slots
   */
  const getRequestSlots = useCallback(async (requestId: string) => {
    console.log("🟢 [API] getRequestSlots:", requestId);
    return await newApi.getRequestSlots(requestId);
  }, []);

  /**
   * PATCH /requests/{id}/confirm-slot - Confirm a time slot
   */
  const confirmSlot = useCallback(async (requestId: string, slotId: string) => {
    console.log("🟢 [API] confirmSlot:", requestId, slotId);
    return await newApi.confirmSlot(requestId, slotId);
  }, []);

  // ===== REQUESTS - ADMIN =====

  /**
   * GET /requests/all - Get all requests (Admin)
   */
  const getAllRequests = useCallback(async () => {
    console.log("🟢 [API] getAllRequests");
    return await newApi.getAllRequests();
  }, []);

  /**
   * PATCH /requests/{id}/validate - Validate and assign teacher
   */
  const validateRequest = useCallback(
    async (requestId: string, data: ValidateRequestDto) => {
      console.log("🟢 [API] validateRequest:", requestId, data);
      return await newApi.validateRequest(requestId, data);
    },
    [],
  );

  /**
   * PATCH /requests/{id}/reject - Reject a request
   */
  const rejectRequest = useCallback(
    async (requestId: string, data: RejectRequestDto) => {
      console.log("🟢 [API] rejectRequest:", requestId, data);
      return await newApi.rejectRequest(requestId, data);
    },
    [],
  );

  // ===== REQUESTS - TEACHER =====

  /**
   * POST /requests/{id}/propose-slots - Propose time slots
   */
  const proposeSlots = useCallback(
    async (requestId: string, data: ProposeSlotsDto) => {
      console.log("🟢 [API] proposeSlots:", requestId, data);
      return await newApi.proposeSlots(requestId, data);
    },
    [],
  );

  /**
   * POST /requests/{id}/meetings - Create meeting
   */
  const createMeeting = useCallback(
    async (requestId: string, data: CreateMeetingDto) => {
      console.log("🟢 [API] createMeeting:", requestId, data);
      return await newApi.createMeeting(requestId, data);
    },
    [],
  );

  // ===== REQUESTS - COMMON =====

  /**
   * GET /requests/{id} - Get request by ID
   */
  const getRequestById = useCallback(async (requestId: string) => {
    console.log("🟢 [API] getRequestById:", requestId);
    return await newApi.getRequestById(requestId);
  }, []);

  // ===== MEETINGS =====

  /**
   * GET /meetings/{id} - Get meeting by ID
   */
  const getMeetingById = useCallback(async (meetingId: string) => {
    console.log("🟢 [API] getMeetingById:", meetingId);
    return await newApi.getMeetingById(meetingId);
  }, []);

  /**
   * PATCH /meetings/{id}/link - Update Google Meet link
   */
  const updateMeetingLink = useCallback(
    async (meetingId: string, data: UpdateMeetingLinkDto) => {
      console.log("🟢 [API] updateMeetingLink:", meetingId, data);
      return await newApi.updateMeetingLink(meetingId, data);
    },
    [],
  );

  /**
   * GET /meetings/request/{requestId} - Get meeting by request
   */
  const getMeetingByRequest = useCallback(async (requestId: string) => {
    console.log("🟢 [API] getMeetingByRequest:", requestId);
    return await newApi.getMeetingByRequest(requestId);
  }, []);

  return {
    // Students
    createRequest,
    getMyRequests,
    getRequestSlots,
    confirmSlot,

    // Admin
    getAllRequests,
    validateRequest,
    rejectRequest,

    // Teacher
    proposeSlots,
    createMeeting,

    // Common
    getRequestById,

    // Meetings
    getMeetingById,
    updateMeetingLink,
    getMeetingByRequest,
  };
};

export default useRequestsApi;

// Export types
export type {
  CreateRequestInput,
  ValidateRequestDto,
  RejectRequestDto,
  ProposeSlotsDto,
  CreateMeetingDto,
  UpdateMeetingLinkDto,
  RequestResponse,
  MeetingResponse,
};
